import { cn } from "@/lib/utils";

export function Container({ className, children, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...rest} className={cn("mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-8", className)}>
      {children}
    </div>
  );
}

export function EyebrowLabel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "text-display text-xs font-semibold uppercase tracking-[0.28em] text-gold",
        className,
      )}
    >
      {children}
    </p>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  action,
  className,
}: {
  eyebrow?: string;
  title: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mb-6 flex flex-wrap items-end justify-between gap-4", className)}>
      <div>
        {eyebrow ? <EyebrowLabel>{eyebrow}</EyebrowLabel> : null}
        <h2 className="mt-2 text-display text-3xl uppercase leading-none text-navy sm:text-4xl md:text-5xl">
          {title}
        </h2>
      </div>
      {action ? <div className="ml-auto">{action}</div> : null}
    </div>
  );
}

export function GoldRule({ className }: { className?: string }) {
  return <div className={cn("h-[3px] w-16 bg-gold", className)} />;
}
